<div
  id="uzd-protocol"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="sh_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Вік:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_vik" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Щитовидна залоза розташована:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="sh_roztash">
            <option value="типово">типово</option>
            <option value="не типово">не типово</option>
            <option value="оперована">оперована</option>
            <option value="не оперована">не оперована</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Капсула:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_capsula" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Об'єм правої частки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_p_chastka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ізоекогенна', 'sh_p_eho')"> ізоекогенна </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('підвищена ехогенність', 'sh_p_eho')"> підвищена ехогенність </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ехогенність:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="sh_p_eho"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Структура:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_p_strycture" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Об'єм лівої частки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_l_chastka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ізоекогенна', 'sh_l_eho')"> ізоекогенна </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('підвищена ехогенність', 'sh_l_eho')"> підвищена ехогенність </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ехогенність:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="sh_l_eho"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Структура:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_l_strycture" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Перешийок:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_pereshuyok" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Загальний об'єм залози:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="sh_zagal_ob" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки аутоімунного тиреоїдиту', 'sh_results')"> ознаки аутоімунного тиреоїдиту </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки вузнового зобу', 'sh_results')"> ознаки вузнового зобу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки дифузного зобу', 'sh_results')"> ознаки дифузного зобу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('варіант норми', 'sh_results')"> варіант норми </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гіпертрофія', 'sh_results')"> гіпертрофія </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('гіпертрофія щитової залози', 'sh_results')"> гіпертрофія щитової залози</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Висновок:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="sh_results"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
<!--        <button class="btn btn-primary" (click)="copyDataToTextArea('', 'sh_results')">  </button>-->
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рекомендовано:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="sh_recomends"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
